import { render, staticRenderFns } from "./AttrWebpage.vue?vue&type=template&id=de979f6c&scoped=true"
import script from "./AttrWebpage.vue?vue&type=script&lang=js"
export * from "./AttrWebpage.vue?vue&type=script&lang=js"
import style0 from "./AttrWebpage.vue?vue&type=style&index=0&id=de979f6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de979f6c",
  null
  
)

export default component.exports